export function transformInvoiceContactAddress2ModelToUI(
  value: string | null | undefined
): string {
  return value ?? '';
}
